import * as _ from 'lodash';

import { api } from '../axiosConfig';
import {surveysURL, surveyEmailSchedule, samplesURL, resendSurveyEmailSchedule} from "../Utils/urls";

export class SurveysAPI {
    static getAll(
        limit : any,
        pagenumber: number,
        payload: { [key: string]: any },
        offset = 0,
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getAll/${limit}/${pagenumber}`, payload).then((res) => {
            return _.get(res, 'data', []);
        });
    }

    // fromDate / toDate: plain 'YYYY-MM-DD' (India calendar days, toDate
    // inclusive). Never pass a Date or ISO instant (DXD-7359).
    static getInFieldStats(
        id: string,
        fromDate?: string,
        toDate?: string,
        status?: string | null,
    ): Promise<any> {
        return api.post(`${surveysURL}/inFieldStats/${id}`, { fromDate, toDate, status })
            .then((res) => _.get(res, 'data.data', { dateRange: null, stats: [] }));
    }

    static getPartnerMarketStats(
        parentSurveyId: string,
        partnerId: string,
    ): Promise<any[]> {
        return api.post(`${surveysURL}/partnerMarketStats/${parentSurveyId}/${partnerId}`, {})
            .then((res) => _.get(res, 'data.data', []));
    }

    static create(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/create`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getOne(
        id : string
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getOne/${id}`, {})
        .then((res) => {
            return _.get(res, 'data', {});
        });
    }

    static getOneDetails(
        id : string,
        limit : any,
        pagenumber: number,
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getOneDetails/${id}/${limit}/${pagenumber}`, {})
        .then((res) => {
            return _.get(res, 'data', {});
        });
    }

    static getpantnerdetailsmain(
        id : string
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getpantnerdetailsmain/${id}`, {})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    static getOneDXPanelOnly(
        id : string
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getOneDXPanelOnly`, {id})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    // filter: the In-Field Stats filter — optional plain 'YYYY-MM-DD' dates
    // (cut at India midnight by the backend) and Status; same row rules as
    // getInFieldStats (DXD-7359).
    static getAllPartnerUsersexport(
        id : string,
        filter: { fromDate?: string; toDate?: string; status?: string } = {},
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getAllPartnerUsersexport/${id}`, { ...filter })
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    // Returns the all-users export as a raw Blob. The endpoint streams a
    // binary .zip (xlsx inside) — `responseType: 'blob'` makes the axios
    // response interceptor skip decryption, and the request interceptor
    // still attaches the Authorization header so auth is preserved.
    // GET matches the backend route verb (Surveys.route.js).
    static getSurveyDetailsExport(
        id : string
    ): Promise<Blob> {
        return api.get(`${surveysURL}/getSurveyDetailsExport/${id}`, {
            responseType: 'blob',
        }).then((res) => {
            return res.data as Blob;
        });
    }

    static update(id: string, payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/update/${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getChildSurveys(parentId: string): Promise<any[]> {
        return api.post(`${surveysURL}/getChildSurveys/${parentId}`, {})
            .then((res) => {
                return _.get(res, 'data.data', []);
            });
    }

    // Edit Survey → child tab pool snapshot. Used by ChildSurveyTab.tsx to
    // render the Available / Claimed / Consumed / Total table when the child
    // has useUniqueLinks=true. POST chosen over GET so the existing axios
    // request interceptor injects userAuthId + encrypts the body, matching
    // every other endpoint in this file.
    static getUniqueLinksStats(surveyId: string): Promise<{ available: number; claimed: number; consumed: number; total: number } | null> {
        return api.post(`${surveysURL}/getUniqueLinksStats/${surveyId}`, {})
            .then((res) => {
                return _.get(res, 'data.data', null);
            });
    }

    static deleteOne(id: string): Promise<any> {
        return api.post(`${surveysURL}/delete/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static addPartners(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/add-partners`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }



    static getAllTemplate(
        id: string,
        limit = 100000,
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getAll-template/${id}/${limit}`, {})
        .then((res) => {
            return _.get(res, 'data.data', []);
        });
    }

    static createTemplate(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/create-template`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getOneTemplate(
        id : string,
        surveyId?: string,
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getOne-template/${id}`, { surveyId })
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    static updateTemplate(id: string, payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/update-template/${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static deleteOneTemplate(id: string): Promise<any> {
        return api.post(`${surveysURL}/delete-template/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }



    static getAllEmailSchedule(
        id: string,
        limit = 100000,
    ): Promise<any[]> {
        return api.post(`${surveyEmailSchedule}/getAll/${id}/${limit}`, {})
        .then((res) => {
            return _.get(res, 'data.data', []);
        });
    }

    static createEmailSchedule(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveyEmailSchedule}/create`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getOneEmailSchedule(
        id : string,
        surveyId?: string
    ): Promise<any[]> {
        return api.post(`${surveyEmailSchedule}/getOne/${id}`, surveyId ? { surveyId } : {})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    static updateEmailSchedule(id: string, payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveyEmailSchedule}/update/${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static deleteEmailSchedule(id: string, surveyId?: string): Promise<any> {
        return api.post(`${surveyEmailSchedule}/delete/${id}`, surveyId ? { surveyId } : {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static sendInviteNow(id: string, surveyId?: string): Promise<any> {
        return api.post(`${surveyEmailSchedule}/sendNow/${id}`, surveyId ? { surveyId } : {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static downloadUsers(id: string): Promise<any> {
        return api.post(`${samplesURL}/getOneSampleAllUsers/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }


    static panelistSurveys(id: string): Promise<any> {
        return api.post(`${surveysURL}/panelist-surveys/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static panelistOneSurvey(id: string): Promise<any> {
        return api.post(`${surveysURL}/panelist-one-surveys/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    // Universal returns C1: reconciliation upload (preview is read-only).
    static reconcilePreview(payload: { surveyId: string; rows: { row: number; id: string; status: string }[] }): Promise<any> {
        return api.post(`${surveysURL}/reconcile/preview`, payload)
            .then((res) => _.get(res, 'data.data', null));
    }

    static reconcileApply(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/reconcile/apply`, payload)
            .then((res) => _.get(res, 'data.data', null));
    }

    // Universal returns B2: partner entries vs returns per client / host /
    // survey over 2h / 24h / 7d, with the red flags (read-only).
    static redirectHealth(): Promise<any> {
        return api.post(`${surveysURL}/redirectHealth`, {})
            .then((res) => _.get(res, 'data.data', null));
    }

    // withCredentials: the browser's dxs respondent cookie (set when it was
    // handed to the client survey) goes with the POST; the backend prefers it
    // over the ids in the link (universal returns A2).
    static GetUserOneAssignedSurveyCallback(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/GetUserOneAssignedSurveyCallback`, payload, { withCredentials: true })
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static surveyPartner(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/createSurveyPartnerUser`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static userRespondentDashboardWeb(userId: any, language = 'en'): Promise<any> {
        return api.post(`${surveysURL}/userRespondentDashboardWeb/${userId}?language=${language}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static adminRespondentDashboardWeb(): Promise<any> {
        return api.post(`${surveysURL}/adminRespondentDashboardWeb`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static partnerSurveyUsers(selectPartners, surveyId): Promise<any> {
        return api.post(`${surveysURL}/getAllPartnerUsers/${selectPartners}/${surveyId}`, {})
            .then((res) => {
                return _.get(res, 'data.data', []);
            });
    }

    static uploadBulkRewards(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/uploadBulkRewards`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static fetchSurveyOverviewStatus(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/surveyOverviewStatus`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static fetchProjectOverviewStatus(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/projectOverviewStatus`, payload)
            .then((res) => {
                return _.get(res, 'data.data', []);
            });
    }

    static fetchClientOverviewStatus(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/clientOverviewStatus`, payload)
            .then((res) => {
                return _.get(res, 'data.data', { totalCompletes: 0, partners: [] });
            });
    }

    static fetchProjectNamesDropdown(params: { page: number; limit: number; search: string }): Promise<any> {
        return api.get(`${surveysURL}/dropdown/projects`, { params }).then((res) => _.get(res, 'data.data', { data: [], total: 0, page: 1 }));
    }

    static fetchClientNamesDropdown(params: { page: number; limit: number; search: string }): Promise<any> {
        return api.get(`${surveysURL}/dropdown/clients`, { params }).then((res) => _.get(res, 'data.data', { data: [], total: 0, page: 1 }));
    }

    static ResendReminderApi(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${resendSurveyEmailSchedule}/resendsendNow`, payload)
            .then((res) => {
                // Return the response data directly
                return res.data;
            })
            .catch((error) => {
                // Handle the error appropriately
                console.error("Error in ResendReminderApi:", error);
                throw error; // Rethrow the error to be handled in the calling function
            });
    }


    static deletePartner(id: string): Promise<any> {
        const payload = {
            partnerId: id,
        };
        return api.post(`${surveysURL}/destroy-Partner`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error deleting partner:', error.message);
                throw error; // Rethrow the error for further handling
            });
    }

    static surveysamplecount(surveyId: string, sampleId: string): Promise<any> {
        return api.post(`${surveysURL}/surveysamplecount`, {surveyId, sampleId, })
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error survey sample count:', error.message);
                throw error;
            });
    }

    static duplicatesurvey(payload: any): Promise<any> {
        return api.post(`${surveysURL}/duplicatesurvey`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error duplicate survey:', error.message);
                throw error;
            });
    }

    static duplicatesurveyWithSameRedirects(payload: any): Promise<any> {
        return api.post(`${surveysURL}/duplicatesurveyWithSameRedirects`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error duplicate survey for same redirects:', error.message);
                throw error;
            });
    }

    // Same-market segment duplicate for a CHILD survey.
    // Backend picks parent + segment number and preserves uniqueid / country / shortName.
    static duplicateChild(id: string): Promise<any> {
        return api.post(`${surveysURL}/duplicateChild/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error duplicate child survey:', error.message);
                throw error;
            });
    }

    static testSurvey(payload: any): Promise<any> {
        return api.post(`${surveysURL}/testSurvey`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error test survey:', error.message);
                throw error;
            });
    }

    static testuniqueLinks(payload: any): Promise<any> {
        return api.post(`${surveysURL}/testuniqueLinks`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error test unique links :', error.message);
                throw error;
            });
    }

    static testuniqueLinksPartners(payload: any): Promise<any> {
        return api.post(`${surveysURL}/testuniqueLinksPartners`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error test unique links partner :', error.message);
                throw error;
            });
    }

    static resendpartnerUserLinks(payload: any): Promise<any> {
        return api.post(`${surveysURL}/resendpartnerUserLinks`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error test unique links partner :', error.message);
                throw error;
            });
    }

    static getMarketsOfSurvey(payload: any): Promise<any> {
        return api.post(`${surveysURL}/getMarketsOfSurvey`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error get markets of survey :', error.message);
                throw error;
            });
    }

    static downloadPartnerUniqueLinks(payload: any): Promise<any> {
        return api.post(`${surveysURL}/downloadPartnerUniqueLinks`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error download test unique links partner :', error.message);
                throw error;
            });
    }

    static getPartnerUsersexport(payload: any): Promise<any> {
        return api.post(`${surveysURL}/getPartnerUsersexport`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error download test unique links partner :', error.message);
                throw error;
            });
    }

    static resendpartnerUsersDownload(payload: any): Promise<any> {
        return api.post(`${surveysURL}/resendpartnerUsersDownload`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error download resend partner users :', error.message);
                throw error;
            });
    }

    static getLeftQuotaPoints(payload: any): Promise<any> {
        return api.post(`${surveysURL}/getLeftQuotaPoints`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error left quota points :', error.message);
                throw error;
            });
    }

    static getPartnerTestIdsOnTheBasisOfStatus(payload: any): Promise<any> {
        return api.post(`${surveysURL}/getPartnerTestIdsOnTheBasisOfStatus`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error in Ids :', error.message);
                throw error;
            });
    }

    static updateSurveyStatusOnly(payload: any): Promise<any> {
        return api.post(`${surveysURL}/updateSurveyStatusOnly`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error in update status :', error.message);
                throw error;
            });
    }

    static pmDashboard(): Promise<any> {
        return api.post(`${surveysURL}/pmDashboard`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error in pm dashboard :', error.message);
                throw error;
            });
    }

    // Detailed respondent records for the PM Dashboard today-status cards.
    // `status` is the URL slug — one of 'completed' | 'disqualified' | 'quotafull' | 'securityterm'.
    static getTodayStatusDetails(status: string): Promise<any> {
        return api.post(`${surveysURL}/todayStatusDetails/${status}`, {})
            .then((res) => {
                return _.get(res, 'data.data', { status: '', rows: [], total: 0 });
            })
            .catch((error) => {
                console.error('Error getTodayStatusDetails:', error.message);
                throw error;
            });
    }

    static pmListAPI(): Promise<any> {
        return api.post(`${surveysURL}/pmListAPI`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error in update status :', error.message);
                throw error;
            });
    }

    // partnerId: partner entry page (knows the partner). userId: prescreener
    // page (knows only the respondent id; for a vendor respondent that is a
    // partnerusers row id and the backend derives the partner from it).
    static checkVerisoulEnabled(id: string, partnerId?: string, userId?: string) {
        const query = partnerId
            ? `?partnerId=${encodeURIComponent(partnerId)}`
            : (userId ? `?userId=${encodeURIComponent(userId)}` : '');
        const url = `${surveysURL}/checkVerisoulEnabled/${id}${query}`;
        return api.get(url)
            .then((res) => {
                return _.get(res, 'data.verisoul', false);
            })
            .catch((e) => {
                console.log("Error checking verisoul status:", e);
                return false;
            });
    }
}
